







































































import { VNode, CreateElement } from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { TableEntry, SwTable, TableColumnConfig, ColumnsAdjustRequestData, TableEntrySelectingEventData, TableEntryFloatAction } from '@libs-uuif/shared/sw-table';
// import  { MswApiService } from '@/shared/msw-api-service';
import { UserGroup, SelectedUserGroupObjectType, UsersForUserGroupType } from './userGroupTypes';
import { AccessManagementStoreState } from '../msw-accessmgmt-store';

const cssPrefix = 'users-container';
@Component({
  components: {
    ...UUIFComponents,
    SwTable,
  },
})
export default class UsersContainer  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  usersCount = 0;
  searchString: string = '';
  usersTableData: TableEntry[] = [];
  adjustedColumns: ColumnsAdjustRequestData = {};
  userGroupFromApi: UserGroup[] = [];
  filteredData: TableEntry[] = [];
  userGroupDataEntry: SelectedUserGroupObjectType = {
    partyGroupName: '',
    isDefaultGroup: '',
    partyGroupId: '',
    adminPartyId: '',
    status: '',
    totalContacts: '',
    productGroupName: '',
    associatedPGList: [],
    setAsDefaultGroup: '',
    renameLink: '',
    usersForUserGroup: [],
    deleteLink: '',
    mgeProdGrpPagelink: '',
    isReadOnlyAccess: '',
    MSSPID: '',
    isAllMSSPTenants: '',
    msspScope: '',
    scopedMSSPID: '',
  };
  isREstrictedMsspFromApi = '';
  @Prop({ required: false })
  userGroup: string;

  /* tslint:disable-next-line */
  getFloatActions(entry: TableEntry, scope: any = this): TableEntryFloatAction[] {
    return [
      {
        icon: { name: 'trash' },
        action: (entry: TableEntry) => {
          this.$emit('deleteUser', entry);
        },
      },
    ];
  }

  get tableData() {
    return this.filteredData;
  }

  commonOnEntrySelecting(data: TableEntrySelectingEventData, toSet: Set<string>, toShadow: string[]) {
    if (data.selecting) {
      toSet.add(data.entryKey);
      this.setSelectedUserState(data.entryKey);
    } else {
      toSet.delete(data.entryKey);
    }
    toShadow.splice(0);
    Array.prototype.push.apply(toShadow, Array.from(toSet));
  }

  singleSelectedEntries = new Set<string>();
  shadowSingleSelectedEntries: string[] = [];
  onSingleSelectEntry(data: TableEntrySelectingEventData) {
    this.commonOnEntrySelecting(data, this.singleSelectedEntries, this.shadowSingleSelectedEntries);
  }

  setSelectedUserState(index: string) {
    const selctedUserRow = this.filteredData[Number(index)];
    const selectedUsersObject = Object.assign({}, {
      name: selctedUserRow.name,
      login: selctedUserRow.login,
      email: selctedUserRow.email,
      partyGroupId: selctedUserRow.partyGroupId,
      contactId: selctedUserRow.contactId,
      partyId: selctedUserRow.partyId,
      adminPartyId: selctedUserRow.adminPartyId,
      lastAccessDate: selctedUserRow.lastAccessDate,
      dtLastAccessDate: selctedUserRow.dtLastAccessDate,
      lastAccessTime: selctedUserRow.lastAccessTime,
      isReadOnlyAccess: selctedUserRow.isReadOnlyAccess,
    });
    this.$store.commit('AccessManagementStoreModule/setSelectedUserObject', { selectedUserObject: selectedUsersObject });
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  usersColumnConfig: TableColumnConfig[] = [{
    key: 'name',
    dataKey: 'name',
    title: String(this.$t('accessMgmt.name')),
    render(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
      return (
        <div class={['users-container__lastActive']}>
          <div class={['users-container__lastActive_header']}>{data.entry.name}</div>
          <div>{data.entry.email}</div>
        </div>
      ) as VNode;
    },
  }, {
    key: 'lastActive',
    dataKey: 'lastActive',
    title: String(this.$t('accessMgmt.lastActive')),
    width: 120,
    render(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
      return (
        <div class={['users-container__lastActive']}>
          <div class={['users-container__lastActive_header']}> {data.entry.lastAccessTime}</div>
          <div>{data.entry.lastAccessDate}</div>
        </div>
      ) as VNode;
    },
  }];

  performSearch() {
    const obj = this.searchString.toString()
    .toLocaleLowerCase();
    if (obj !== '') {
      this.filteredData = this.usersTableData.filter((row: any) => {
        let flag = false;
        for (const key in row) {
          if (Object.prototype.hasOwnProperty.call(row, key)) {
            flag = row[key] ? row[key].toString()
            .toLocaleLowerCase()
            .includes(obj) : false;
            if (flag) {
              return flag;
            }
          }
        }
        return false;
      });
    } else {
      this.filteredData = [...this.usersTableData];
    }
  }

  addUser() {
    this.$emit('addUserFn');
  }

  @State((state: any) => state.AccessManagementStoreModule.selectedUserGroupObject)
  readonly selectedUserGroupObject: AccessManagementStoreState['selectedUserGroupObject'];

  get usersEntry() {
    return this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
  }

  @Watch('usersEntry', { deep: true })
  formatUsersTable() {
    this.userGroupDataEntry = this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
    const usersData = this.userGroupDataEntry.usersForUserGroup || [];
    this.isREstrictedMsspFromApi = this.$store.getters['AccessManagementStoreModule/getisRestrictedMSSPAccess'];
    this.usersTableData = usersData.map((ele: UsersForUserGroupType, index: number) => {
      return {
        _key: index.toString(),
        name: ele.name,
        login: ele.login,
        email: ele.email,
        partyGroupId: ele.partyGroupId,
        contactId: ele.contactId,
        partyId: ele.partyId,
        adminPartyId: ele.adminPartyId,
        lastAccessDate: ele.lastAccessDate,
        dtLastAccessDate: ele.dtLastAccessDate,
        lastAccessTime: ele.lastAccessTime,
        isReadOnlyAccess: ele.isReadOnlyAccess,
      };
    });
    this.filteredData = [...this.usersTableData];
  }

  created() {
    this.formatUsersTable();
  }
}
